module.exports = __webpack_public_path__ + "img/com8.7baf1b5d.gif";